import { IEltCompanyPerformanceItem } from 'legacy/lut/classes/models/partner360/ELT/docEltType/IEltCompanyPerfomance'

export const getCompanyPerformanceInitialValues = (data: IEltCompanyPerformanceItem[]) => {
  return data.sort((a, b) => {
    const aOrder = a.OrderBy ?? Infinity
    const bOrder = b.OrderBy ?? Infinity
    return aOrder - bOrder
  })
}
